/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ViedocMenuItemElement } from "../../../../../secure/elements/ViedocReactElements";
import * as fileUploadActions from "../../../../../store/actions/fileUploadActions";
import APP_CONST from "../../../../shared/constants";
import * as UtilsHelper from "../../../../../../utils/utilsHelper";
import * as documentActions from "../../../../../store/actions/documentActions";

const DownloadOptions = ({
  isBinderProperties,
  setShowDownloadOptions,
  showDownloadOptions,
  docDetailsList,
}) => {
  const dispatch = useDispatch();
  const { docShareCount, isBinderDetail, binderDetails } = useSelector(
    (state) => state.document
  );
  const { fullDateTimePattern } = useSelector((state) => state.template);
  const {
    isDocShareViedocUser,
    isDocShareViedocMeUser,
    isReadOnlySharingPanel,
    studyUserInfo,
  } = useSelector((store) => store.zone);
  const checkIsValidRecall = () => {
    if (
      binderDetails &&
      !binderDetails.isRecalled &&
      binderDetails.isRecalledMenu &&
      (isDocShareViedocUser || isDocShareViedocMeUser)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isReadOnlySharing = () => {
    if (
      isReadOnlySharingPanel &&
      !isDocShareViedocUser &&
      !isDocShareViedocMeUser
    ) {
      return true;
    } else {
      return false;
    }
  };
  const onDownloadFn = () => {
    const payload = {
      requestPaylod: {
        fileguid: docDetailsList.documentguid,
        documentid: docDetailsList.documentid,
        documentversionguid: docDetailsList.documentversionguid,
        lastmodifiedon: docDetailsList.lastmodifiedon,
        isfrometmfbinder: isBinderDetail ? true : false,
      },
      downloadInfo: {
        downloadFileName: docDetailsList.origfilename,
        type: docDetailsList.type,
      },
    };
    if (isBinderDetail) {
      payload.requestPaylod = {
        ...payload.requestPaylod,
        binderId: binderDetails.binderId,
      };
    }
    dispatch(fileUploadActions.fileDownloadUrl(payload, false));
    setShowDownloadOptions(false);
  };
  const downloadFile = (fileprops) => {
    dispatch(
      fileUploadActions.fileDownloadUrl(
        UtilsHelper.prepareDownloadReq(fileprops),
        false
      )
    );
  };
  const downloadWithNoBinders = () => {
    const origfilename = docDetailsList.origfilename.split(
      `.${docDetailsList.type}`
    )[0];
    const downloadFileName =
      docDetailsList.downloadtemplate && docDetailsList.downloadtemplate !== ""
        ? docDetailsList.downloadtemplate
        : docDetailsList.title === "customName"
        ? docDetailsList.customTitle
        : APP_CONST.TITLE_ARRAY.includes(docDetailsList.title)
        ? docDetailsList.documenttypevalue ||
          (docDetailsList.artifact && docDetailsList.artifact.name)
        : origfilename;
    const fileProps = {
      ...docDetailsList,
      downloadFileName,
    };
    downloadFile(fileProps);
    setShowDownloadOptions(false);
  };
  const downloadSharingDetailsZipFile = () => {
    dispatch(fileUploadActions.showDownloadLoader(true));
    setShowDownloadOptions(false);
    let validFilename = UtilsHelper.fileExtensionRemoval(
      docDetailsList.origfilename
    );
    const requestPayload = {
      sharingbinderid: binderDetails.sharingBinderId,
      sharinguserid: "00000000-0000-0000-0000-000000000000",
      studyguid: studyUserInfo.studyGuid,
      studyname: studyUserInfo.studyName,
      isrequestfrometmf: true,
      filedateformat: fullDateTimePattern,
      language:
        studyUserInfo.language !== undefined && studyUserInfo.language !== ""
          ? studyUserInfo.language
          : "en",
      friendlyfilename: `${validFilename}_Sharing details.zip`,
    };
    dispatch(
      documentActions.downloadSharingDetails(
        requestPayload,
        `${validFilename}_Sharing details.zip`
      )
    );
  };
  const onDownloadWithSignature = () => {
    let validFilename = UtilsHelper.fileExtensionRemoval(
      docDetailsList.origfilename
    );
    let requestPayload = !binderDetails.isOnlySignatureAvailable
      ? {
          bindersId: binderDetails.sharingBinderId,
          fileName: binderDetails.signatureFileGuid,
          isfrometmfbinder: true,
          friendlyfilename: `${validFilename}_Signature.pdf`,
          isToGetSignedFile: true,
        }
      : {
          signaturedocid: binderDetails.signatureFileGuid,
          fileguid: docDetailsList.documentguid,
          docname: `${validFilename}.${docDetailsList.type}`,
          binderid: binderDetails.binderId,
          isfrometmfbinder: true,
        };
    if (!binderDetails.isOnlySignatureAvailable) {
      dispatch(
        documentActions.downloadSignatureDetails(
          requestPayload,
          binderDetails.isOnlySignatureAvailable
        )
      );
    } else {
      downloadSignatureDetailsWithouSas(requestPayload);
    }
    setShowDownloadOptions(false);
  };
  const downloadSignatureDetailsWithouSas = (requestPayload) => {
    dispatch(fileUploadActions.showDownloadLoader(true));
    setShowDownloadOptions(false);
    let validFilename = UtilsHelper.fileExtensionRemoval(
      docDetailsList.origfilename
    );
    const reqPayload = {
      signaturedocid: binderDetails.signatureFileGuid,
      fileguid: docDetailsList.documentguid,
      docname: docDetailsList.origfilename,
      binderid: binderDetails.binderId,
      studyguid: studyUserInfo.studyGuid,
      userid: "00000000-0000-0000-0000-000000000000",
      sharinguserid: "00000000-0000-0000-0000-000000000000",
      isfrometmfbinder: true,
      friendlyfilename: `${validFilename}_Signature.zip`,
    };
    dispatch(
      documentActions.downloadSignatureZipDetails(
        reqPayload,
        `${validFilename}_Signature.zip`
      )
    );
  };
  const recallSharing = () => {
    let reqPayload = {
      sharingbinderid: binderDetails.sharingBinderId,
      documentid: docDetailsList.documentid,
      lastmodifiedon: binderDetails.lastModifiedOn,
      latestdocumentversionid: docDetailsList.documentversionguid,
    };
    dispatch(documentActions.reCallBinder(reqPayload));
    setShowDownloadOptions(false);
  };
  let downloadList = [
    {
      label: t("TMF.BUTTON_DOWNLOADORIGINIALRECORD"),
      value: "downloadOriginalFile",
      disabled: false,
      visible: true,
    },
    {
      label: t("TMF.BUTTON_SHARINGDETIALSZIP"),
      value: "downloadWithSharingDetails",
      disabled: false,
      visible: isBinderDetail,
    },
    {
      label: t("TMF.BUTTON_SINGNATUREDETIALS"),
      value: "downloadWithSignatures",
      disabled: binderDetails && !binderDetails.isDownloadEnable,
      visible: isBinderDetail && !isReadOnlySharing(),
    },
    {
      label: t("TMF.BUTTON_DOWNLOADNOTES"),
      value: "downloadWithNotes",
      disabled: binderDetails && !binderDetails.isNotesAvailable,
      visible: isBinderDetail && !isReadOnlySharing(),
    },
    {
      label: t("TMF.BUTTON_REVOKESHARING"),
      value: "revokeSharing",
      disabled: !checkIsValidRecall(),
      visible: isBinderDetail && !isReadOnlySharing(),
    },
  ];

  const onDownloadWithNotes = () => {
    let validFilename = UtilsHelper.fileExtensionRemoval(docDetailsList.origfilename);
    let requestPayload = {
      sharingBinderId: binderDetails.sharingBinderId,
      fileName: binderDetails.notesFileGuid,
      isfrometmfbinder: true, 
      friendlyFileName:`${validFilename}_Notes.pdf`,
    };
    dispatch(documentActions.downloadWithNotes(requestPayload));
    setShowDownloadOptions(false);
  };

  const downloadHandler = (e) => {
    if (e.target.disabled) return;

    switch (e.target.value) {
      case "downloadOriginalFile":
        if (docShareCount.availableBindersCount >= 1) {
          onDownloadFn();
        } else {
          downloadWithNoBinders();
        }
        break;
      case "downloadWithSharingDetails":
        downloadSharingDetailsZipFile();
        break;
      case "downloadWithSignatures":
        onDownloadWithSignature();
        break;
      case "downloadWithNotes":
        onDownloadWithNotes();
        break;
      case "revokeSharing":
        recallSharing();
        break;
      default:
        break;
    }
  };

  return (
    <div
      className="download-options"
      style={{ top: isBinderProperties ? "18rem" : "9rem" }}
    >
      <viedoc-menu onClick={(e) => downloadHandler(e)}>
        {downloadList.map((option) => (
          <>
            {option.visible && (
              <ViedocMenuItemElement
                key={option.value}
                disabled={option.disabled}
                value={option.value}
                title={option.label}
              >
                {option.label}
              </ViedocMenuItemElement>
            )}
          </>
        ))}
      </viedoc-menu>
    </div>
  );
};

export default DownloadOptions;
